import PropTypes from "prop-types";
import { Box, Button, ListItem } from "@mui/material";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
export const NavItem = (props) => {
    const { to, icon, title, ...others } = props;
    const location = useLocation();
    const active = to ? location.pathname === to : false;

    useEffect(() => {
        if (location.pathname === to) {
            document.title = title;
        }
    });

    return (
        <>
            <ListItem
                disableGutters
                sx={{
                    display: "flex",
                    mb: 0.5,
                    py: 0,
                    px: 2
                }}>
                <Link to={to} style={{ width: "100%", textDecoration: "none" }}>
                    <Button
                        component="a"
                        startIcon={icon}
                        disableRipple
                        sx={{
                            background: active ? "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)" : "transparent",
                            borderRadius: "8px",
                            color: "#ffffff",
                            fontWeight: active ? 700 : 600,
                            fontSize: "14px",
                            justifyContent: "flex-start",
                            px: 2.5,
                            py: 1,
                            textAlign: "left",
                            textTransform: "none",
                            width: "100%",
                            boxShadow: active ? "0 4px 12px rgba(2,132,199,0.35)" : "none",
                            "& .MuiButton-startIcon": {
                                color: "#ffffff",
                                fontSize: "18px"
                            },
                            "&:hover": {
                                background: active ? "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)" : "rgba(255,255,255, 0.12)"
                            }
                        }}>
                        <Box sx={{ flexGrow: 1 }}>{title}</Box>
                    </Button>
                </Link>
            </ListItem>
        </>
    );
};

NavItem.propTypes = {
    href: PropTypes.string,
    icon: PropTypes.node,
    title: PropTypes.string
};
